

const baseURL = process.env.REACT_APP_API_BASE_URL;
const baseDashboardURL = process.env.REACT_APP_DASHBOARD_BASE_URL;



export const APIConstants = {
  // * Request Types
  GET: "get",
  PUT: "put",
  POST: "post", 
  DELETE: "delete",
  // GET_WITH_TOKEN: "getWithToken",
  API_BASE_URL: baseURL + "",

  // API Paths(GROUPS)
  GET_APPLICATION_MODULE_DETAILS: baseURL + "/TVSDashBoard/GetApplicationModulesDetails",
  GET_REPORT_STATUS_MASTER_DETAILS: baseURL + "/TVSDashBoard/GetReportStatusMasterDetails",
 GET_FLOW_GROUP_DETAILS: baseURL + "/GetFlowGroupDetails", 
 INSERT_FLOW_GROUP_DETAILS: baseURL + "/InsertFlowGroupDetails",
 UPDATE_FLOW_GROUP_DETAILS: baseURL + "/UpdateFlowGroupDetails",
 DELETE_FLOW_GROUP_DETAILS: baseURL + `/DeleteFlowGroupDetails`,
//  http://20.244.40.160:81/DeleteFlowGroupDetails?GroupID=7&IsDelete=true


//API Paths(GROUP_METER)
GET_FLOW_GROUP_METER_DETAILS: baseURL + "/GetFlowGroupMeterDetails",
USP_LIST_SITES: baseURL + "/TVSDashBoard/Getsites",
GET_GROUP_METER_NAME_DETAILS: baseURL +`/TVSDashBoard/NSGetFlowConverterDetails`,
INSERT_FLOW_GROUP_METER_DETAILS: baseURL + "/InsertFlowGroupMeterDetails",
UPDATE_FLOW_GROUP_METER_DETAILS: baseURL + "/UpdateFlowGroupMeterDetails",
DELETE_FLOW_GROUP_METER_DETAILS: baseURL + `/DeleteFlowGroupMeterDetails`,


// API Paths(SUB_METER)
GET_FLOW_SUB_GROUPS_DETAILS:  baseURL + `/GetFlowSubGroupsDetails`,
GET_CALCULATION_TYPE_MASTER_DETAILS: baseURL + "/TVSDashBoard/GetCalculationTypeMasterDetails",
INSERT_FLOW_SUB_GROUP_METER_DETAILS: baseURL + "/InsertFlowSubGroupsDetails",
UPDATE_FLOW_SUB_GROUP_METER_DETAILS:  baseURL + "/UpdateFlowSubGroupsDetails",
DELETE_FLOW_SUB_GROUP_METER_DETAILS:   baseURL + `/DeleteFlowSubGroupsDetails`,



//Electrical APIs
//tree dashboard data
TREE_CHART_DATA_QUERY: baseURL + "/TVSTreeDashBoardData",
ELECTRICAL_LIVE_CHART: baseURL + "/api/Electrical/LiveChart",
ELECTRICAL_COMPARATIVE_REPORT : baseURL + "/api/Electrical/Comparitive",
ELECTRICAL_RAWDATA : baseURL + "/api/Electrical/RawData",
ELECTRICAL_HISTORICAL_REPORT : baseURL + "/api/Electrical/Historicaltrends",
ELECTRICAL_METER_STATUS : baseURL + "/api/Electrical/Meterstatus",
ELECTRICAL_PARAMETER_VIEW : baseURL + "/api/Electrical/Parmeterview",
ELECTRICAL_CONSUMPTION_REPORT : baseURL + "/api/Electrical/Consumptionreport",
ELECTRICAL_METERS_LIST : baseURL + "/api/Electrical/MeterDetails",
ELECTRICAL_HISTORICAL_PARAMETERS_LIST : baseURL + "/api/Electrical/HistoricalParameters",
ELECTRICAL_METERS_DETAILS : baseURL + "/api/Electrical/MeterDetails",
ELECTRICAL_PARAMETER_DETAILS : baseURL + "/api/Electrical/LiveParameters",
ELECTRICAL_COVERTER_DETAILS : baseURL + "/api/Electrical/MeterDetails",
ELECTRICAL_INSERT_GROUP : baseURL + "/api/Electrical/InsertGroupDetails",
ELECTRICAL_INSERT_SUB_GROUP : baseURL + "/api/Electrical/insertsubgroupdetails",
ELECTRICAL_GROUP_DETAILS : baseURL + "/api/Electrical/Getgroupdetails",
ELECTRICAL_SUB_GROUP_DETAILS : baseURL + "/api/Electrical/GetSubGroupsDetails",
ELECTRICAL_GROUP_DELETE : baseURL + "/api/Electrical/Deletegroup",
ELECTRICAL_SUB_GROUP_DELETE : baseURL + "/api/Electrical/Deletesubgroup",

ELECTRICAL_GROUP_NAME: baseURL + "/api/Electrical/Getgroupdetails",
ELECTRICAL_CONSUMPTION_DETAILS : baseURL + "/api/Electrical/Getparameters",
ELECTRICAL_SUB_GROUPDETAILS : baseURL + "/api/Electrical/GetSubGroupsDetails",
ELECTRICAL_GROPU_REPORT : baseURL + "/api/Electrical/Getgroupreport",
ELCTRICAL_METER_DETAILS : baseURL +"/api/Electrical/GetGroupMeterDetails",
ELECTRICAL_INSERT_GROUP_DETAILS : baseURL + "/api/Electrical/insertGroupMeterDetails",
ELECTRICAL_GROUP_METER_DETAILS : baseURL + "/api/Electrical/GetGroupMeterDetails",

//reset childern and entity data
RESET_CALCULATIONS_MUTATION: baseURL + "/DeleteEntityAndChildMeter", 



//Plant Chart APIs
TVS_GET_DEPARTMENTS: baseURL + "/TVSDashBoard/GetDepartments",
GET_PLANT_NAME : baseURL + "/Getplantname",
GET_CHART_CONTROL :baseURL + "/Getchartcontrol",
GET_COMBINED_PLANT_DATA : baseURL + "/GetCombinedPlantData",
INSERT_PLANT_NAMES :baseURL + "/InsertplantNames",
INSERT_PLANT_NAME_DETAILS : baseURL + "/InsertplantNamesdetails",
DELETE_PLANT_NAME_DETAILS :baseURL + "/DeletePlantNamedetails",
DELETE_PLANT_NAME_MASTER :baseURL +"/DeletePlantNamemaster",
UPDATE_PLANT_NAME_DETAILS :baseURL + "/UpdatePlantNamedetails",
UPDATE_PLANT_NAME_MASTER :baseURL + "/UpdatePlantNamemaster",




//Live chart APIs
GET_FLOW_CONVERTER_DETAILS :baseURL + "/TVSDashBoard/GetFlowConverterDetails",
GET_ELECTRICAL_CONVERTER_DETAILS :baseURL + "/GetConverterDetails",
GET_FLOW_SECTION_MASTER :baseURL + "/TVSDashBoard/GetFlowSectionMaster",
GET_FLOW_STEAM_GROUP_METER_DETAILS: baseURL + "/TVSDashBoard/GetFlowSteamGropeMeterDetails",
GET_STEAM_CONVERTER_LIVE_CHART:baseURL + "/TVSDashBoard/GetsteamConverterLiveChart",
GET_STEAM_METER_STATUS_DETAILS: baseURL + "/TVSDashBoard/GetsteamMeterStatusDetails",


// Steam Layout API 
GET_STEAM_DASHBOARD_DATA : baseURL + "/TVSTreeDashBoardSteamData",  
GET_STEAM_AGGREGATION_PERIOD  : baseURL + "/TVSDashBoard/GetAggregationPeriod",
GET_TREE_CHART_DATA : baseURL + "/TVSTreeDashBoardData",
GET_STEAM_METER_STATUS_DETAILS : baseURL + "/TVSDashBoard/GetsteamMeterStatusDetails",
GET_FLOW_SECTION_MASTER_DETAILS : baseURL + "/TVSDashBoard/GetFlowSectionMaster",
GET_FLOW_NS_CONVERTER_DETAILS : baseURL + "/TVSDashBoard/NSGetFlowConverterDetails",
GET_FLOW_CONVERTER_DETAILS :baseURL +"/TVSDashBoard/GetFlowConverterDetails",
GET_FLOW_STEAM_GROUP_METER_DETAILS : baseURL +  "/TVSDashBoard/GetFlowSteamGropeMeterDetails",
GET_STEAM_CONVERTER_LIVE_CHART :baseURL + "/TVSDashBoard/GetsteamConverterLiveChart",









GET_STEAM_FLOW_GROUP_DETAILS : baseURL +  "/GetFlowGroupDetails",
GET_TVS_GAUGE_DASHBOARD_DATA :baseURL + "/TVSDashBoard/GetTVSGauageDashboardData",//gauge chart api 
GET_STEAM_DASHBOARD_CONVERTOR_STATUS : baseURL + "/TVSDashBoard/ConverterStaus",
GET_STEAM_DASHBOARD_COMPARATIVE_DATA : baseURL + "/TVSDashBoard/Getsteamcomparativedata",
GET_STEAM_DASHBOARD_RAWDATA_DETAILS : baseURL + "/TVSDashBoard/GetsteamRawDataDetails", 
GET_STEAM_DASHBOARD_HISTORICAL_DETAILS : baseURL + "/TVSDashBoard/GetsteamHistoricalDetails",
STEAM_GROUP_CONSUMPTION_REPORT : baseURL + "/TVSDashBoard/SteamGroupConsumption",
STEAM_CONVERTOR_CONSUMPTION_REPORT : baseURL + "/TVSDashBoard/SteamConverterConsumption",





//WATER APIS
GET_LIVE_CHART_DATA_WATER : baseURL + "/TVSDashBoard/GetWaterConverterLiveChart",
GET_FLOW_CONVERTER_DETAILS_WATER : baseURL + "/TVSDashBoard/GetWaterConverterStaus",
GET_FLOW_SECTION_MASTER_DETAILS_WATER : baseURL + "/TVSDashBoard/GetFlowSectionMaster",
GET_GROUP_DETAILS_WATER: baseURL + "/GetWaterGroupDetails",
GET_METER_STATUS_DETAILS_WATER: baseURL +  "/TVSDashBoard/GetWaterMeterStatusDetails",
GET_RAW_DATA_WATER: baseURL + "/TVSDashBoard/GetWaterRawDataDetails",
GET_HISTORICAL_DETAILS_WATER : baseURL + "/TVSDashBoard/GetWaterHistoricalDetails",
GET_COMPARITIVE_REPORT_WATER : baseURL + "/TVSDashBoard/WaterMeterDataDetailsForComparitive",
GET_COMPARITIVE_GROUP_WATER : baseURL + "/TVSDashBoard/ConsumptionforGroup",
GET_COMPARITIVE_CONVERTER_WATER : baseURL + "/TVSDashBoard/Consumptionforconverter",



//AIR APIS
GET_LIVE_CHART_AIR :baseURL + "/api/Air/GetAirLivechart",
GET_METER_STATUS_AIR : baseURL +"/api/Air/GetAirMeterstatus",
GET_CONVERTOR_STATUS_AIR :baseURL + "/api/Air/GetAirConverterStatus",
GET_COMPARATIVE_REPORT : baseURL + "/api/Air/AirComparitive",
GET_AIR_RAW_DATA :baseURL + "/api/Air/AirRawData",
GET_AIR_HISTORICAL_DATA : baseURL + "/api/Air/GetAirHistorical",
GET_CONSUMPTION_REPORT_AIR_CONVERTER : baseURL + "/api/Air/AirConsumptionforconverter",
GET_CONSUMPTION_REPORT_AIR_GROUP : baseURL + "/api/Air/AirConsumptionforGroup",




//TEMPERATURE APIS
GET_LIVE_TRENDS_TEMPERATURE :baseURL + "/Livetemperature",
GET_METER_STATUS_TEMPERATURE :baseURL + "/MeterStatustemp",
GET_CONVERTER_STATUS_TEMPERATURE :baseURL + "/convertertemp",
GET_COMPARATIVE_TEMPERATURE :baseURL + "/TempComparitive",
GET_RAWDATA_TEMPERATURE :baseURL + "/Rawdatatemp",
GET_CONSUMPTION_TEMPERATURE :baseURL + "/consumptiontemp",
GET_HISTORICAL_TRENDS_TEMPERATURE :baseURL + "/Histtrendstemp",
TEMP_METERS_LIST : baseURL + "/tempmeterdetails",
TEMP_GETSITES : baseURL + "/TVSDashBoard/Getsites",

// Confirguration
GET_CONFIG_CONVERTER : baseURL + "/GetConverterDetails",
GET_MODULES : baseURL + "/GetModule",
CONFIG_INSERT_CONVERTER : baseURL + "/InsertConverterdetails",
DELETE_CONFIG_CONVERTER: baseURL +"/DeleteConverterDetails",
CONFIG_INSERT_METER: baseURL + "/InsertDevicedetails",
DELETE_CONFIG_METER : baseURL + "/DeleteMeterDetails",
UPDATE_CONFIG_METER: baseURL + "/UpdateDevicedetails",
GET_CONFIG_METER : baseURL + "/GetDeviceDetails",
GET_METER_LOCATION : baseURL + "/DeviceLocation",
GET_METER_MODAL_DETAILS : baseURL + "/Modeldetails",
GET_DEVICES_DETAILS : baseURL + "/GetDeviceDetails",
DELETE_DEVICE_DETAILS: baseURL + "/DeleteDeviceDetails",













// dashboard apis 
LUCAS_LIVE_GAUGE : baseDashboardURL+ "/LucasLiveGauges",
  LUCAS_LIVE_DATA_TABLE : baseDashboardURL+ "/Livedata",
  LUCAS_LIVE_PLNAT_DEMAND_DETAILS : baseDashboardURL+ "/plantdemanddetails",
  LUCAS_LIVE_DAILY_CONSUMPTION : baseDashboardURL+ "/LucasDailyConsumption",
  LUCAS_LIVE_KWT : baseDashboardURL+ "/GetLiveKwtvalue",
  LUCAS_LIVE_HOURLY_CONSUMPTION : baseDashboardURL+ "/LucasHourlyConsumption",
  LUCAS_LIVE_WEEKLY_CONSUMPTION : baseDashboardURL+ "/LucasWeeklyConsumption",
  LUCAS_LIVE_11kv_CONSUMPTION : baseDashboardURL+ "/Lucas11KvVCBConsumptiontrend",
  LUCAS_LIVE_TRANSFORMER_CONSUMPTION : baseDashboardURL+ "/LucasTransformersVCBConsumptiontrend",
  LUCAS_SF6VCB_CONSUMPTION : baseDashboardURL+ "/SF6VCBConsumptiontrend",
  LUCAS_TOOL_ROOM : baseDashboardURL+ "/ToolRoomConsumptiontrend",
  LUCAS_PHOSPHATING : baseDashboardURL+ "/PhosphatingConsumptiontrend",
  DG_CONSUMPTION : baseDashboardURL+ "/Dgconsumption",
  DG_LIVE : baseDashboardURL+ "/dglivedata",
  PRODUCTION_DATA : baseDashboardURL+ "/ProductionDataDetails",
  GAUGES_LIVE_VOLTAGE : baseDashboardURL+ "/GetGaugesLiveVoltage",
  GAUGES_LIVE_DEMAND : baseDashboardURL+ "/GetGaugesLiveDemand",
  GAUGES_LIVE_CURRENT : baseDashboardURL+ "/GetGaugeLiveCurrent",
  GAUGES_LIVE_POWER_FACTOR : baseDashboardURL+ "/GetGaugeLivePowerFactor",
  UPDATE_GAUGE_DETAILS : baseDashboardURL+ "/UpdateDashBoardGaugeDetails",
};

// GetTVSGauageDashboardData?PlantID=9&FromDate=2024-07-17%207%3A15%3A00.000&Todate=2024-07-17%207%3A25%3A00.000 